// extracted by mini-css-extract-plugin
module.exports = {"card-action-area":"ImageCard_card-action-area__3PeqB"};